"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _vehicleSelection = require("../../actions/vehicleSelection");

var _reactRedux = require("react-redux");

var _VehicleSelector = require("../../components/steps/VehicleSelector");

var _VehicleSelector2 = _interopRequireDefault(_VehicleSelector);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapStateToProps(state) {
  var _state$vehicleSelecti = state.vehicleSelection,
      availableBrands = _state$vehicleSelecti.availableBrands,
      availableModels = _state$vehicleSelecti.availableModels,
      availableTypes = _state$vehicleSelecti.availableTypes,
      brandId = _state$vehicleSelecti.brandId,
      modelId = _state$vehicleSelecti.modelId,
      typeId = _state$vehicleSelecti.typeId;
  var _state$formData = state.formData,
      mileage = _state$formData.mileage,
      registerDate = _state$formData.registerDate,
      licensePlate = _state$formData.licensePlate,
      fin = _state$formData.fin,
      garageId = _state$formData.garageId;
  return {
    availableBrands: availableBrands,
    availableModels: availableModels,
    availableTypes: availableTypes,
    brandId: brandId,
    modelId: modelId,
    typeId: typeId,
    brand: availableBrands[brandId],
    model: availableModels[modelId],
    type: availableTypes[typeId],
    mileage: mileage,
    registerDate: registerDate,
    licensePlate: licensePlate,
    fin: fin,
    garageId: garageId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadBrands: function loadBrands(garageId) {
      return dispatch((0, _vehicleSelection.loadBrands)(garageId));
    },
    selectBrand: function selectBrand(garageId, brandId) {
      return dispatch((0, _vehicleSelection.selectBrand)(garageId, brandId));
    },
    selectModel: function selectModel(garageId, modelId) {
      return dispatch((0, _vehicleSelection.selectModel)(garageId, modelId));
    },
    selectType: function selectType(typeId) {
      return dispatch((0, _vehicleSelection.selectType)(typeId));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  var garageId = stateProps.garageId;
  return _extends({}, stateProps, dispatchProps, ownProps, {
    loadBrands: function loadBrands() {
      return dispatchProps.loadBrands(garageId);
    },
    selectBrand: function selectBrand(brandId) {
      return dispatchProps.selectBrand(garageId, brandId);
    },
    selectModel: function selectModel(modelId) {
      return dispatchProps.selectModel(garageId, modelId);
    }
  });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_VehicleSelector2.default);